import { useSnackbar } from 'notistack'
import { useTranslation } from 'react-i18next'

import { TEN_SECONDS } from '../../libs/time'
type UseInputAlertPopupProps = {
	name: string
}

const useInputAlertPopup = ({ name }: UseInputAlertPopupProps) => {
	const { t } = useTranslation()
	const { enqueueSnackbar } = useSnackbar()
	const getFieldInfoString = (name: string): string => {
		if (name.includes('sph')) {
			return t('doctor.Sphere')
		} else if (name.includes('cyl')) {
			return t('doctor.Cylinder')
		} else if (name.includes('axis')) {
			return t('doctor.Axis')
		} else {
			const lastSegment = name.split('.').pop() || name
			const iopMatch = lastSegment.match(/^iop(.*)$/i)
			const iopSuffix = iopMatch ? iopMatch[1] : ''
			if (!iopSuffix) return t('doctor.IOP')
			if (/^\d+$/.test(iopSuffix)) return `${t('doctor.IOP')} ${iopSuffix}`
			return `${t('doctor.IOP')}${iopSuffix}`
		}
	}

	const _fieldInfoString = getFieldInfoString(name)
	const showPopup = (
		type: 'error' | 'warning',
		noteRequired: boolean = true,
		overrideName?: string,
	) => {
		const fieldInfoString = overrideName
			? getFieldInfoString(overrideName)
			: _fieldInfoString
		const translationKey = noteRequired ? type : 'warningWONote'

		const message = t(`inputAlert.popup.${translationKey}`, {
			inputName: fieldInfoString,
		})

		enqueueSnackbar({
			autoHideDuration: TEN_SECONDS,
			anchorOrigin: { horizontal: 'right', vertical: 'top' },
			variant: 'inputAlert',
			critical: type === 'error',
			message,
		})
	}

	return { showPopup }
}

export default useInputAlertPopup
